module.exports = __webpack_public_path__ + "src/images/products/active/15_Seersucker Performance Golf Short.png";